import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  photo: css`
    inline-size: ${spacing(7)};
    block-size: ${spacing(7)};
    border-radius: ${spacing(2)};
    object-fit: cover;
    margin-block-start: ${spacing(1)};
    display: inline-block;
    margin-inline-start: ${spacing(1)};
  `,
  container: css`
    display: block;
  `,
}
